/**
 * @generated SignedSource<<1f0d8556f726cb62ba279560bbbc8cef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableHead_package$data = {
  readonly rooms: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"RoomNameWithCapacity_room">;
  }>;
  readonly " $fragmentType": "RoomRatesTableHead_package";
};
export type RoomRatesTableHead_package$key = {
  readonly " $data"?: RoomRatesTableHead_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableHead_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableHead_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Room",
      "kind": "LinkedField",
      "name": "rooms",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomNameWithCapacity_room"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "5f2b8f9a8623a76e8b6c32582bf609be";

export default node;
